import React, { useState, useEffect, useMemo } from "react";
import { IconButton, Dialog, DialogContent, DialogTitle, Box, Typography, Paper, Card, Grid, Avatar, Button } from '@mui/material';
import { UrlApi } from "../../../../services/apirest";
import { getData } from "../../../../services/library";
import { BarChart } from '@mui/x-charts';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { grey } from "@mui/material/colors";

export default function EstadisticaPedidos(props) {
    const { open, setopen, dataCliente } = props;

    //aca me guardo lo que obtengo del backend
    const [cantPedidos, setcantPedidos] = useState([]); //la totalidad de pedidos
    const [pedidosDireccion, setpedidosDireccion] = useState([]);
    const [datosAnteriores, setdatosAnteriores] = useState([]);
    const [cantPedidosAnterior, setcantPedidosAnterior] = useState([]);
    const [mes, setMes] = useState(new Date().getMonth() + 1); // Mes actual (1-12)
    const [anio, setAnio] = useState(new Date().getFullYear()); // Año actual
    // Estados adicionales
    const [datosPorMes, setDatosPorMes] = useState({ fechas: [], seriesData: [] });
    const [compararAnioAnterior, setCompararAnioAnterior] = useState(false); // Estado para alternar comparación

    const handleObtenerDatos = async () => {
        try {
            await fetch(`${UrlApi}/estadistica_pedidos/all/${dataCliente.id}`)
                .then(data => data.json())
                .then(data => setcantPedidos(data))
        } catch (error) {
            console.error("Error obteniendo datos", error)
        }
    };

    const handleObtenerDatosPorDireccion = async () => {
        getData(`/estadistica_pedidos/direccion/${dataCliente.id}`, setpedidosDireccion);
    };

    const handleObtenerDatosAnteriores = async () => {
        getData(`/estadistica_pedidos/anioanterior/${dataCliente.id}`, setdatosAnteriores)
    };

    const handleObtenerCantidadAñoAnterior = async () => {
        getData(`/estadistica_pedidos/cantidad_anioanterior/${dataCliente.id}`, setcantPedidosAnterior);
    }

    useEffect(() => {
        handleObtenerDatos();
        handleObtenerDatosPorDireccion()
    }, [dataCliente.id]);

    useEffect(() => {
        handleObtenerDatosAnteriores()
        handleObtenerCantidadAñoAnterior()
    }, [compararAnioAnterior]);

    const meses = datosPorMes.fechas.map(date =>
        new Intl.DateTimeFormat('es-AR', { month: 'long' }).format(date)
    );

    const handleMesAnterior = () => {
        if (mes === 1) {
            setMes(12);
            setAnio(anio - 1);
        } else {
            setMes(mes - 1);
        }
    };

    const handleMesSiguiente = () => {
        if (mes === 12) {
            setMes(1);
            setAnio(anio + 1);
        } else {
            setMes(mes + 1);
        }
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === '+') {
                handleMesSiguiente(); // Llama a la función de mes siguiente
            } else if (event.key === '-') {
                handleMesAnterior(); // Llama a la función de mes anterior
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        // Limpia el listener al desmontar el componente
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [mes, anio]);

    // Función para procesar los datos
    const processDatosMensuales = (data) => {
        const now = new Date();
        const currentYear = now.getFullYear();
        const previousYear = currentYear - 1;

        const datosPorAnioMes = data.reduce((acc, pedido) => {
            const anio = pedido.anio;
            const mesStr = `${anio}-${String(pedido.mes).padStart(2, '0')}`;
            if (!acc[mesStr]) {
                acc[mesStr] = { kilosTotales: 0 };
            }
            acc[mesStr].kilosTotales += pedido.kilos_totales || 0;
            return acc;
        }, {});

        const fechas = [];
        const kilosActual = [];
        const kilosAnterior = compararAnioAnterior ? [] : null;

        for (let m = 0; m < 12; m++) {
            const mesStrActual = `${currentYear}-${String(m + 1).padStart(2, '0')}`;
            const mesStrAnterior = `${previousYear}-${String(m + 1).padStart(2, '0')}`;
            fechas.push(new Date(currentYear, m, 1));

            kilosActual.push(datosPorAnioMes[mesStrActual]?.kilosTotales || 0);
            if (compararAnioAnterior) {
                kilosAnterior.push(datosPorAnioMes[mesStrAnterior]?.kilosTotales || 0);
            }
        }

        // 🔥 Agregás colores acá
        const seriesData = [
            {
                label: `Kilos Totales ${currentYear}`,
                data: kilosActual,
                color: '#1976d2', // Azul
            },
        ];

        if (compararAnioAnterior) {
            seriesData.push({
                label: `Kilos Totales ${previousYear}`,
                data: kilosAnterior,
                color: '#9c27b0', // Naranja
            });
        }

        setDatosPorMes({ fechas, seriesData });
    };


    // useEffect para obtener datos
    useEffect(() => {
        const fetchDatosPorMes = async () => {
            try {
                const response = await fetch(
                    `${UrlApi}/estadistica_pedidos/comparar?id_cliente=${dataCliente.id}&comparar=${compararAnioAnterior}`
                );
                const data = await response.json();
                // console.log("Datos por mes:", data);
                processDatosMensuales(data);
            } catch (error) {
                console.error("Error al obtener datos por mes:", error);
                setDatosPorMes({ fechas: [], seriesData: [] });
            }
        };
        if (dataCliente.id) {
            fetchDatosPorMes();
        }
    }, [dataCliente.id, compararAnioAnterior]); // Dependencia en compararAnioAnterior


    //unifico las filas para hacer la comparacion con año anterior para que me muestre todas las direcciones del cliente
    //no importa si este año se entregó o no pedidos.


    const filas = useMemo(() => {
        const map = new Map();

        // Año actual
        pedidosDireccion?.forEach(d => {
            map.set(d.id_direccion, {
                id_direccion: d.id_direccion,
                direccion: d.direccion_entrega,
                nombre: d.nombre_direccion,
                kilos_actual: Number(d.kilos_totales) || 0,
                kilos_anterior: 0,
                kilos_sort: !compararAnioAnterior
                    ? Number(d.kilos_totales) || 0
                    : 0
            });
        });

        // Año anterior
        if (compararAnioAnterior) {
            datosAnteriores?.forEach(d => {
                if (map.has(d.id_direccion)) {
                    const row = map.get(d.id_direccion);
                    row.kilos_anterior = Number(d.kilos_totales) || 0;
                    row.kilos_sort = Number(d.kilos_totales) || 0;
                } else {
                    map.set(d.id_direccion, {
                        id_direccion: d.id_direccion,
                        direccion: d.direccion_entrega,
                        nombre: d.nombre_direccion,
                        kilos_actual: 0,
                        kilos_anterior: Number(d.kilos_totales) || 0,
                        kilos_sort: Number(d.kilos_totales) || 0
                    });
                }
            });
        }

        return Array.from(map.values()).sort(
            (a, b) => b.kilos_sort - a.kilos_sort
        );

    }, [pedidosDireccion, datosAnteriores, compararAnioAnterior]);

    // console.log("filas", filas);

    // console.log("cantPorDireccion", cantPorDireccion);
    // console.log("mes", mes);
    // console.log("anio", anio);
    // console.log("años anteriores", datosAnteriores);
    // console.log("cantidad ", cantPedidos)
    // console.log( "canti pedidos anterior", cantPedidosAnterior)
    // console.log("seriesdata", datosPorMes.seriesData)

    return (
        <>

            <Dialog open={open} onClose={() => { setopen(false) }} fullScreen>
                {/* <Navbar/> */}
                <Box justifyContent="center" backgroundColor="#1F618D">
                    <DialogTitle>
                        <Grid
                            container
                            p={1}
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Grid item xs={1}>
                                <IconButton onClick={() => setopen(false)}>
                                    <ArrowBackIcon sx={{ color: grey[50] }} />
                                </IconButton>
                            </Grid>
                            <Grid item xs={11}>
                                <Typography variant="h5" align="center" color="#ffffff">
                                    {dataCliente.razon_social ?? dataCliente.cliente}
                                </Typography>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                </Box>

                <DialogContent>
                    <Box width="100%" justifyContent="center" height="100%">
                        <Grid container spacing={2} direction={{ xs: 'column', sm: 'row' }}>
                            {/* Left Column: Stacked Items */}
                            <Grid item xs={12} sm={4}>
                                {/* Cantidad de Pedidos */}
                                <Paper elevation={3} sx={{ p: 2, borderRadius: 2, borderColor: "blue", mb: 2 }}>
                                    <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
                                            Pedidos Registrados Anual
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
                                            {(() => {
                                                const estadosEntregados = [248, 25, 263];
                                                // console.log("cant pedidos", cantPedidos);

                                                // Agrupamos los pedidos actuales
                                                const pedidosAgrupados = cantPedidos.reduce((acc, pedido) => {
                                                    const { id_estado, cantidad } = pedido;

                                                    const key = estadosEntregados.includes(id_estado) ? 999 : id_estado;

                                                    const existente = acc.find(p => p.id_estado === key);
                                                    if (existente) {
                                                        existente.cantidad += cantidad;
                                                    } else {
                                                        acc.push({ id_estado: key, cantidad });
                                                    }
                                                    return acc;
                                                }, []);

                                                // Mapeo de nombres de estado
                                                const estadoMap = {
                                                    999: 'Entregados',
                                                    32: 'Cancelados',
                                                    21: 'Pendientes',
                                                    23: 'Asignados',
                                                    19: "Pendiente",


                                                };

                                                // Colores por estado
                                                const getColor = (id) => {
                                                    if (id === 999) return 'success.main';
                                                    if (id === 32) return 'error.main';
                                                    if (id === 21) return '#eaf576';
                                                    if (id === 23) return 'primary.main';
                                                    if (id === 19) return '#b9c258ff';
                                                    return 'grey.300';
                                                };

                                                return pedidosAgrupados.map((pedido, index) => {
                                                    const estadoNombre = estadoMap[pedido.id_estado] || `Estado ${pedido.id_estado}`;
                                                    return (
                                                        <Box key={index} sx={{ display: 'flex', flexDirection: 'column-reverse', alignItems: 'center' }}>
                                                            <Avatar
                                                                sx={{
                                                                    bgcolor: getColor(pedido.id_estado),
                                                                    width: 56,
                                                                    height: 56,
                                                                    mb: 3,
                                                                    fontSize: '1.5rem',
                                                                    fontWeight: 'bold',
                                                                }}
                                                            >
                                                                {pedido.cantidad}
                                                            </Avatar>
                                                            <Typography variant="caption" sx={{ mt: 0.5, textTransform: 'capitalize' }}>
                                                                {estadoNombre}
                                                            </Typography>
                                                        </Box>
                                                    );
                                                });
                                            })()}
                                        </Box>

                                        {compararAnioAnterior && (
                                            <>
                                                <Typography variant="h6" fontWeight="bold" sx={{ mt: 2, mb: 2 }}>
                                                    Pedidos Registrados Año Anterior
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
                                                    {(() => {
                                                        const estadosEntregados = [248, 25, 263];

                                                        // Agrupamos los pedidos del año anterior
                                                        const pedidosAgrupadosAnteriores = cantPedidosAnterior.reduce((acc, pedido) => {
                                                            const { id_estado, cantidad } = pedido;
                                                            const key = estadosEntregados.includes(id_estado) ? 999 : id_estado;

                                                            const existente = acc.find(p => p.id_estado === key);
                                                            if (existente) {
                                                                existente.cantidad += cantidad;
                                                            } else {
                                                                acc.push({ id_estado: key, cantidad });
                                                            }
                                                            return acc;
                                                        }, []);

                                                        // Mapeo de nombres de estado
                                                        const estadoMap = {
                                                            999: 'Entregados',
                                                            32: 'Cancelados',
                                                            21: 'Pendientes',
                                                            23: 'Asignados',
                                                            19: 'Pendiente'
                                                        };

                                                        // Colores por estado
                                                        const getColor = (id) => {
                                                            if (id === 999) return 'success.main';
                                                            if (id === 32) return 'error.main';
                                                            if (id === 21) return '#eaf576';
                                                            if (id === 23) return 'primary.main';
                                                            if (id === 19) return '#b9c258ff';
                                                            return 'grey.300';
                                                        };

                                                        return pedidosAgrupadosAnteriores.map((pedido, index) => {

                                                            const estadoNombre = estadoMap[pedido.id_estado] || `Estado ${pedido.id_estado}`;

                                                            return (
                                                                <Box key={index} sx={{ display: 'flex', flexDirection: 'column-reverse', alignItems: 'center' }}>
                                                                    <Avatar
                                                                        sx={{
                                                                            bgcolor: getColor(pedido.id_estado),
                                                                            width: 56,
                                                                            height: 56,
                                                                            mb: 3,
                                                                            fontSize: '1.5rem',
                                                                            fontWeight: 'bold',
                                                                        }}
                                                                    >
                                                                        {pedido.cantidad}
                                                                    </Avatar>
                                                                    <Typography variant="caption" sx={{ mt: 0.5, textTransform: 'capitalize' }}>
                                                                        {estadoNombre}
                                                                    </Typography>
                                                                </Box>
                                                            );
                                                        });
                                                    })()}
                                                </Box>
                                            </>
                                        )}
                                    </Card>
                                </Paper>

                                {/* Kilos Entregados */}
                                <Paper elevation={3} sx={{ borderRadius: 2, mb: 2 }}>
                                    <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Typography variant="h6" fontWeight="bold">
                                            Kilos Entregados
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <Typography variant="h4" sx={{ mt: 0.5, mb: 1 }}>
                                                    {(cantPedidos?.[0]?.kilos_totales ?? 0).toLocaleString('es-AR', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        {compararAnioAnterior && (
                                            <>
                                                <Typography variant="h6" fontWeight="bold">
                                                    Kilos Entregados Año Anterior
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <Typography variant="h4" sx={{ mt: 0.5, mb: 1 }}>
                                                            {(
                                                                datosAnteriores?.reduce(
                                                                    (sum, item) => sum + (Number(item.kilos_totales) || 0),
                                                                    0
                                                                ) ?? 0
                                                            ).toLocaleString('es-AR', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2,
                                                            })}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </>
                                        )}
                                    </Card>
                                </Paper>

                                {/* Litros/Kilos por Dirección */}
                                <Paper elevation={3} sx={{ p: 2, borderRadius: 2, mb: 3 }}>
                                    <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Typography variant="h6" fontWeight="bold" >
                                            Kilos Entregados Por direccion
                                        </Typography>
                                        <TableContainer
                                            component={Paper}
                                            sx={{
                                                maxHeight: 260,
                                                width: '100%',
                                            }}>
                                            <Table size="small" aria-label="a dense table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Dirección</TableCell>
                                                        <TableCell align="right">Kilos entregados</TableCell>
                                                        {compararAnioAnterior && <TableCell align="right">Año anterior</TableCell>}

                                                    </TableRow>
                                                </TableHead>
                                                {/* <TableBody>
                                                    {pedidosDireccion?.length > 0 ? (
                                                        pedidosDireccion.map((row, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell>{row.direccion_entrega}</TableCell>
                                                                <TableCell align="right">{row.kilos_totales}</TableCell>
                                                                {compararAnioAnterior && (
                                                                    <TableCell align="right">
                                                                        {datosAnteriores.find(d => d.direccion_entrega === row.direccion_entrega)?.kilos_totales || 0}
                                                                    </TableCell>
                                                                )}
                                                            </TableRow>
                                                        ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={compararAnioAnterior ? 3 : 2} align="center">
                                                                No hay datos disponibles
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody> */}
                                                <TableBody>
                                                    {filas.length > 0 ? (
                                                        filas.map((row, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell>{`${row.direccion} (${row.nombre})`}</TableCell>
                                                                <TableCell align="right">
                                                                    {row.kilos_actual.toFixed(2)}
                                                                </TableCell>
                                                                {compararAnioAnterior && (
                                                                    <TableCell align="right">
                                                                        {row.kilos_anterior.toFixed(2)}
                                                                    </TableCell>
                                                                )}
                                                            </TableRow>
                                                        ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={compararAnioAnterior ? 3 : 2} align="center">
                                                                No hay datos disponibles
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>

                                            </Table>
                                        </TableContainer>
                                    </Card>
                                </Paper>

                            </Grid>

                            <Grid item xs={12} sm={8}>
                                <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
                                    <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', mb: 2 }}>
                                            <Typography variant="h6" fontWeight="bold">
                                                Kilos Totales por Mes y Año
                                            </Typography>
                                            <Button
                                                variant="outlined"
                                                onClick={() => setCompararAnioAnterior(!compararAnioAnterior)}
                                            >
                                                {compararAnioAnterior ? "Mostrar solo año actual" : "Comparar con año anterior"}
                                            </Button>
                                        </Box>
                                        {datosPorMes.fechas.length > 0 ? (
                                            <BarChart
                                                xAxis={[
                                                    {
                                                        label: "Mes",
                                                        data: meses,
                                                        scaleType: "band"
                                                    },
                                                ]}
                                                yAxis={[
                                                    {
                                                        valueFormatter: (value) =>
                                                            `${(Number(value) / 1000).toLocaleString('es-AR', { maximumFractionDigits: 2 })} Tn`,
                                                    },
                                                ]}
                                                series={datosPorMes.seriesData}
                                                height={400}
                                            />
                                        ) : (
                                            <Typography variant="body1">Cargando datos...</Typography>
                                        )}
                                    </Card>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>

            </Dialog >

        </>)
}



// const handleObtenerDirecciones = async () => {
//     try {
//         getData(`/direccionesentrega/cli/${dataCliente.id}`, setDirecciones)
//     } catch (error) {
//         console.error("Error al obtener direcciones de entrega", error)
//     }
// };

// const handleObtenerDatosPorDireccion = async () => {
//     console.log("obtengo datos por direccion");
//     try {
//         getData(`/estadistica_pedidos/fecha/${dataCliente.id}/${direccionSeleccionada.id}/${mes}/${anio}`, setcantPorDireccion)
//     } catch (error) {
//         console.error("Error obteniendo datos", error)
//     }
// };
// useEffect(() => {
//     handleObtenerDirecciones()
// }, [])

// useEffect(() => {
//     if (direccionSeleccionada) {
//         handleObtenerDatosPorDireccion()
//     }
// }, [mes, anio, direccionSeleccionada])

// <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
//                             <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                                 <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
//                                     Litros/Kilos por Dirección
//                                 </Typography>
//                                 <Autocomplete
//                                     disableClearable
//                                     disabled={!direcciones}
//                                     options={direcciones}
//                                     fullWidth
//                                     onChange={(event, newValue) => {
//                                         setDireccionSeleccionada(newValue);
//                                     }}
//                                     getOptionLabel={(direccion) => `${direccion.direccion_entrega} (${direccion.nombre_direccion})`}
//                                     renderInput={(params) => (
//                                         <TextField
//                                             required
//                                             style={style}
//                                             focused
//                                             {...params}
//                                             label="Dirección"
//                                             variant="outlined"
//                                             size="small"
//                                             sx={{ mb: 1, width: "85%" }}
//                                         />
//                                     )}
//                                 />
//                                 <div
//                                     style={{
//                                         display: 'flex',
//                                         justifyContent: 'center',
//                                         alignItems: 'center',
//                                         gap: '10px',
//                                         flexWrap: 'wrap',
//                                         flex: '1 1 auto',
//                                     }}
//                                 >
//                                     <IconButton variant="contained" onClick={handleMesAnterior}>
//                                         <RemoveCircleOutline />
//                                     </IconButton>
//                                     <Typography
//                                         variant="subtitle"
//                                         style={{
//                                             width: '200px',
//                                             textAlign: 'center',
//                                         }}
//                                     >
//                                         {meses[mes - 1]} {anio}
//                                     </Typography>
//                                     <IconButton variant="contained" onClick={handleMesSiguiente}>
//                                         <AddCircleOutline />
//                                     </IconButton>
//                                 </div>
//                                 {direccionSeleccionada && Array.isArray(cantPorDireccion) && cantPorDireccion.length > 0 ? (
//                                     cantPorDireccion.map((pedido, index) => (
//                                         <Box key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                                             {pedido.kilos_totales && (
//                                                 <Typography variant="h4" sx={{ mt: 0.5 }}>
//                                                     {pedido.kilos_totales ?? pedido.kgentregados} kg
//                                                 </Typography>
//                                             )}
//                                         </Box>
//                                     ))
//                                 ) : (
//                                     <Typography variant="body1" sx={{ mt: 2 }}>
//                                         {direccionSeleccionada ? "No hay datos disponibles" : "Seleccione una dirección"}
//                                     </Typography>
//                                 )}
//                             </Card>
//                         </Paper>